module.exports = __webpack_public_path__ + "images/emoji/ng.a3343bb7e7b32e73d503.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/ng.png
// module id = PTZ3
// module chunks = 1